import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center flex-column me-3"
}
const _hoisted_2 = {
  href: "#",
  class: "fs-4 fw-bold text-gray-900 text-hover-primary me-1 mb-2 lh-1"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-0 lh-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-success badge-circle w-10px h-10px me-1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-semobold text-gray-400" }, " Active ")
], -1)
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "fs-5 opacity-75 text-dark" }
const _hoisted_7 = { class: "symbol-group symbol-hover" }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "symbol symbol-35px symbol-circle"
}
const _hoisted_11 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconRightArrow = _resolveComponent("IconRightArrow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.isDrawer ? 'd-flex align-items-center justify-content-start pb-2 min-h-30px mt-0' : 'mt-0 pb-2 d-flex align-items-center justify-content-start d-md-block'} pt-6 card-header`)
  }, [
    (_ctx.isDrawer)
      ? (_openBlock(), _createBlock(_component_IconRightArrow, {
          key: 0,
          class: "cursor-pointer svg-icon-dark fa-rotate-180 me-5",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeDrawerChat')))
        }))
      : _createCommentVNode("", true),
    (!_ctx.isDrawer)
      ? (_openBlock(), _createBlock(_component_IconRightArrow, {
          key: 1,
          class: "d-block d-md-none cursor-pointer svg-icon-dark fa-rotate-180 me-5",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('backToHistory')))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.participants == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.userName), 1),
            _hoisted_3
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userName), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participants.slice(0, 8), (participant) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: participant.id,
                  "data-bs-toggle": "tooltip",
                  "data-bs-trigger": "hover",
                  title: participant.name,
                  class: "symbol symbol-35px symbol-circle"
                }, [
                  _createElementVNode("img", {
                    alt: "Pic",
                    src: participant.photo
                  }, null, 8, _hoisted_9)
                ], 8, _hoisted_8))
              }), 128)),
              (_ctx.participants.length > 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("span", {
                      class: "symbol-label fs-8 fw-bold",
                      "data-bs-toggle": "tooltip",
                      "data-bs-trigger": "hover",
                      title: 
                `${_ctx.participants.length - 5} more ${
                  _ctx.participants.length - 5 == 1 ? 'user' : 'users'
                }`
              
                    }, "+ " + _toDisplayString(_ctx.participants.length - 5), 9, _hoisted_11)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ], 2))
}